import React from 'react';

import { OnClick } from '@rbilabs/components-library/build/components/button';
import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ActionButtonSizes, ActionButtonVariants, ActionLink } from 'components/action-button';
import { BackArrowLink } from 'components/navigation/back-arrow';
import useMediaQuery from 'hooks/use-media-query';
import { routes } from 'utils/routing';

interface IProps {
  url?: string;
  onClick?: OnClick;
}

const StyledActionLink = styled(ActionLink)`
  margin: unset;
  position: unset;
`;

const MainMenuLink: React.FC<IProps> = ({ url, onClick }) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');

  return isDesktop ? (
    <StyledActionLink
      size={ActionButtonSizes.SMALL}
      to={url || routes.menu}
      onClick={onClick}
      variant={ActionButtonVariants.OUTLINE}
      startIcon={<Icon icon="previous" color="primary" aria-hidden />}
      color="icon-header-contrast"
    >
      {formatMessage({ id: 'mainMenu' })}
    </StyledActionLink>
  ) : (
    <BackArrowLink to={url || routes.menu} />
  );
};

export default MainMenuLink;
